const OWNER_COLORS: Record<string, string> = {
  melissa: '#7E57C2',
  sam: '#FF007F',
  adam: '#f59e0b',
  ads: '#f59e0b',
  russ: '#2563eb',
  russell: '#2563eb',
};

export const getOwnerColor = (owner?: string): string | undefined =>
  OWNER_COLORS[(owner || '').toLowerCase()];

export const getOwnerColorClass = (owner?: string): string => {
  const key = (owner || '').toLowerCase();
  if (key === 'melissa') return 'owner-melissa';
  if (key === 'sam') return 'owner-sam';
  if (key === 'adam' || key === 'ads') return 'owner-adam';
  if (key === 'russ' || key === 'russell') return 'owner-russ';
  return '';
};
